import { DateTime } from 'luxon';

export default function getTorontoDateTimeFromDate(date: string): DateTime {
  return DateTime.fromISO(date, { zone: 'America/Toronto' });
}
